import { render, staticRenderFns } from "./ynm.vue?vue&type=template&id=e464b846"
import script from "./ynm.vue?vue&type=script&lang=js"
export * from "./ynm.vue?vue&type=script&lang=js"
import style0 from "./ynm.vue?vue&type=style&index=0&id=e464b846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports